import { JoonUIColor, SPACING } from "@joonapp/web-shared"
import { useState } from "react"

import useMobile from "../../hooks/useMobile"

export const SelectRow = ({
  children,
  onClick,
  style,
  hideBorder,
  showBorderBottom,
}: {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  style?: React.CSSProperties
  hideBorder?: boolean
  showBorderBottom?: boolean
}) => {
  // children remain clickable when row is non-interactive (checked with !!onClick)
  const [isHovered, setIsHovered] = useState(false)
  const isMobile = useMobile()

  return (
    <button
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: SPACING.space2,
        padding: SPACING.space3,
        background:
          isHovered && !!onClick && !isMobile
            ? JoonUIColor.background.xlightGray
            : JoonUIColor.background.primaryNeutral,
        borderRadius: hideBorder ? 0 : SPACING.space2,
        overflow: "hidden",
        border: hideBorder ? "none" : `1px solid ${JoonUIColor.border.default}`,
        borderBottom:
          showBorderBottom || !hideBorder
            ? `1px solid ${JoonUIColor.border.default}`
            : "none",
        transition: "background 0.1s ease-in-out",
        cursor: !!onClick ? "pointer" : "default",
        ...style,
      }}
    >
      {children}
    </button>
  )
}
